import { Injectable, signal } from '@angular/core';

/**
 * Service to handle when the app is on mobile
 */
@Injectable({
	providedIn: 'root'
})
export class MobileService {
	mobileView = signal(false);
}
